export default "__VITE_ASSET__BrTwSFum__"